module.exports = __webpack_public_path__ + "c46fd6eefb802116c1e852aac332a37e.svg";